// @ts-nocheck
import * as React from "react";
import { Ic, useCurrentUser, apiErrorMessage } from "./common";
import { referrals } from "../api";

// 기관 담당자용 의뢰 인박스 (/m/referrals).
//
// 기관이 하는 일은 두 가지뿐이다: **받은 의뢰를 보고, 답하는 것.**
// 그래서 화면도 목록 하나 + 응답 버튼 셋으로 끝난다.
//   연락 — 받았고 검토 중 (아직 열린 상태)
//   수용 — 받겠다
//   거절 — 못 받겠다 (사유 필수: 왜 안 됐는지가 남아야 다음 의뢰가 같은 실패를 안 반복한다)
//
// 대상자 정보는 서버가 최소치(이름·나이·주소·필요 급여)만 내려준다 — 위험도·건강상태·
// 연락처는 수락 판단에 필요 없다.

const STATUS_COLOR = {
  pending: "orange", contacted: "sky", accepted: "green", declined: "rose", cancelled: "gray",
};

const StatusBar = () => (
  <div style={{display:'flex', justifyContent:'space-between', padding:'8px 22px 4px', fontSize:11, fontWeight:600, color:'var(--ink-1)', flex:'0 0 auto'}}>
    <span>{new Date().toLocaleTimeString('ko-KR',{hour:'2-digit',minute:'2-digit'})}</span>
    <div style={{display:'flex', gap:5, alignItems:'center'}}>
      <span>●●●</span><span style={{fontSize:10}}>5G</span>
      <span style={{width:18, height:9, border:'1px solid var(--ink-1)', borderRadius:2, position:'relative'}}><span style={{position:'absolute', inset:1, background:'var(--ink-1)'}}/></span>
    </div>
  </div>
);

function fmtWhen(iso) {
  if (!iso) return "";
  const d = new Date(iso), t = new Date();
  const sameDay = d.toDateString() === t.toDateString();
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return sameDay ? `오늘 ${hh}:${mm}` : `${d.getMonth()+1}/${d.getDate()} ${hh}:${mm}`;
}

export function ReferralInbox() {
  const { user, loaded } = useCurrentUser();
  const [tab, setTab]   = React.useState("open");
  const [rows, setRows] = React.useState(null);
  const [openCount, setOpenCount] = React.useState(0);
  const [err, setErr]   = React.useState(null);
  const [toast, setToast] = React.useState(null);

  const load = React.useCallback(() => {
    referrals.list({ status: tab })
      .then(d => { setRows(d.referrals || []); setOpenCount(d.open_count || 0); })
      .catch(e => setErr(apiErrorMessage(e)));
  }, [tab]);
  React.useEffect(() => { if (loaded && user) load(); }, [loaded, user, load]);

  React.useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => setToast(null), 2500);
    return () => window.clearTimeout(t);
  }, [toast]);

  const respond = React.useCallback(async (r, status, note) => {
    setErr(null);
    try {
      const updated = await referrals.respond(r.id, status, note);
      setToast(`${updated.organization_name ? '' : ''}${updated.status_label}(으)로 답했습니다`);
      load();
    } catch (e) { setErr(apiErrorMessage(e)); }
  }, [load]);

  return (
    <div className="app" style={{background:'var(--bg)', overflow:'hidden', display:'flex', flexDirection:'column'}}>
      <StatusBar/>
      <div style={{padding:'10px 22px 6px', flex:'0 0 auto'}}>
        <div style={{fontSize:18, fontWeight:800}}>받은 의뢰</div>
        <div className="muted" style={{fontSize:12, marginTop:2}}>
          {user?.organization_name || '우리 기관'}
          {openCount > 0 && <span style={{color:'var(--orange-700)', fontWeight:700}}> · 처리 대기 {openCount}건</span>}
        </div>
      </div>

      <div style={{display:'flex', gap:6, padding:'6px 22px 10px', flex:'0 0 auto'}}>
        {[['open','처리 대기'], ['resolved','처리 완료']].map(([k, l]) => (
          <button key={k} type="button" onClick={() => { setTab(k); setRows(null); }}
            style={{
              padding:'6px 14px', borderRadius:999, cursor:'pointer', fontSize:12, fontWeight:700,
              border: `1.2px solid ${tab === k ? 'var(--orange-500)' : 'var(--border)'}`,
              background: tab === k ? 'var(--orange-500)' : 'var(--surface)',
              color: tab === k ? '#fff' : 'var(--ink-2)',
            }}>{l}</button>
        ))}
      </div>

      {!loaded && <div className="muted" style={{padding:'30px 22px', textAlign:'center', fontSize:12}}>불러오는 중…</div>}
      {loaded && !user && (
        <div style={{padding:'30px 22px', textAlign:'center'}}>
          <div className="muted" style={{fontSize:13, marginBottom:14}}>로그인이 필요합니다.</div>
          <a href="/login" className="btn btn-primary" style={{padding:'10px 22px', borderRadius:10, textDecoration:'none'}}>로그인</a>
        </div>
      )}

      {user && (
        <div style={{flex:1, overflow:'auto', padding:'0 22px 22px'}}>
          {err && (
            <div style={{padding:'11px 13px', marginBottom:12, background:'var(--rose-50)',
                         border:'1px solid var(--rose-300)', borderRadius:12,
                         fontSize:12.5, color:'var(--rose-700)', fontWeight:600}}>{err}</div>
          )}
          {rows == null && !err && <div className="muted" style={{padding:'24px 0', textAlign:'center', fontSize:12}}>불러오는 중…</div>}
          {rows && rows.length === 0 && (
            <div style={{padding:'34px 16px', textAlign:'center'}}>
              <div style={{fontSize:13, fontWeight:700, marginBottom:6}}>
                {tab === 'open' ? '처리할 의뢰가 없어요' : '처리한 의뢰가 없어요'}
              </div>
              <div className="muted" style={{fontSize:12, lineHeight:1.6}}>
                가용성을 최신으로 유지하면 의뢰가 더 잘 도착합니다.
              </div>
            </div>
          )}
          <div style={{display:'flex', flexDirection:'column', gap:11}}>
            {(rows || []).map(r => <ReferralCard key={r.id} r={r} onRespond={respond}/>)}
          </div>
        </div>
      )}

      {toast && (
        <div role="status" style={{
          position:'absolute', left:22, right:22, bottom:26, padding:'12px 15px',
          background:'var(--ink-1)', color:'var(--bg)', borderRadius:12,
          fontSize:12.5, fontWeight:700, textAlign:'center', boxShadow:'var(--shadow-md)',
        }}>{toast}</div>
      )}
    </div>
  );
}

function ReferralCard({ r, onRespond }) {
  const [declining, setDeclining] = React.useState(false);
  const [reason, setReason] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const color = STATUS_COLOR[r.status] || "gray";

  const act = async (status, note) => {
    setBusy(true);
    try { await onRespond(r, status, note); } finally { setBusy(false); }
  };

  return (
    <div className="card" style={{
      padding:'14px 15px', borderRadius:14,
      border: r.status === 'pending' ? '1.5px solid var(--orange-300)' : '1px solid var(--border)',
    }}>
      <div style={{display:'flex', alignItems:'center', gap:8, marginBottom:3}}>
        <div style={{flex:1, minWidth:0}}>
          <div style={{fontSize:14.5, fontWeight:800}}>{r.elderly_name} 어르신</div>
          <div className="muted" style={{fontSize:11, marginTop:1}}>
            {r.service_label} · {fmtWhen(r.requested_at)} 요청
            {r.requested_by ? ` · ${r.requested_by}` : ''}
          </div>
        </div>
        <span className={"badge badge-" + color} style={{fontSize:11, flex:'0 0 auto'}}>{r.status_label}</span>
      </div>

      {r.note && (
        <div style={{marginTop:8, padding:'9px 11px', background:'var(--bg-sub)', borderRadius:10,
                     fontSize:12.5, color:'var(--ink-1)', lineHeight:1.55}}>
          {r.note}
        </div>
      )}

      {r.response_note && (
        <div className="muted" style={{marginTop:7, fontSize:11.5}}>
          응답: {r.response_note}{r.responded_by ? ` · ${r.responded_by}` : ''}
        </div>
      )}

      {r.open && !declining && (
        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:7, marginTop:11}}>
          <button type="button" disabled={busy} onClick={() => act('contacted')}
            style={btn('sky', busy)}>연락</button>
          <button type="button" disabled={busy} onClick={() => act('accepted')}
            style={btn('green', busy)}>수용</button>
          <button type="button" disabled={busy} onClick={() => setDeclining(true)}
            style={btn('rose', busy)}>거절</button>
        </div>
      )}

      {r.open && declining && (
        <div style={{marginTop:11, display:'flex', flexDirection:'column', gap:8}}>
          <input className="input" value={reason} maxLength={80} autoFocus
                 placeholder="거절 사유 (예: 정원 초과, 구역 밖)"
                 onChange={e => setReason(e.target.value)}
                 style={{fontSize:12.5, padding:'8px 10px'}}/>
          <div className="muted" style={{fontSize:10.5}}>
            왜 안 되는지가 남아야 다음 의뢰가 같은 실패를 반복하지 않습니다.
          </div>
          <div style={{display:'flex', gap:7}}>
            <button type="button" disabled={busy || !reason.trim()}
              onClick={() => act('declined', reason.trim())}
              style={{...btn('rose', busy || !reason.trim()), flex:1}}>거절 보내기</button>
            <button type="button" onClick={() => { setDeclining(false); setReason(""); }}
              style={{...btn('gray', false), flex:'0 0 84px'}}>취소</button>
          </div>
        </div>
      )}
    </div>
  );
}

function btn(color, disabled) {
  return {
    padding:'11px 4px', borderRadius:11, cursor: disabled ? 'not-allowed' : 'pointer',
    border: `1.5px solid var(--${color}-100, var(--border))`,
    background: 'var(--surface)',
    color: `var(--${color}-700, var(--ink-2))`,
    fontWeight:800, fontSize:13.5, opacity: disabled ? 0.5 : 1,
  };
}
